module.exports = __webpack_public_path__ + "img/mala.0c3fdfc1.png";